import { useQuery } from '@tanstack/react-query';
import { companyService } from '@/api/services/CompanyService';
import { useAuth } from '@/stores/authContext';

export const AGENT_INFO_QUERY_KEY = ['agentInfo'] as const;
export const AGENCY_AGREEMENT_QUERY_KEY = ['agencyAgreement'] as const;

// Реквизиты агента площадки (server-state).
export function useAgentInfo() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: AGENT_INFO_QUERY_KEY,
    queryFn: () => companyService.getAgentInfo(),
    enabled: isAuthenticated,
    staleTime: 30 * 60_000,
  });
}

// Файлы агентского договора (server-state).
export function useAgencyAgreement() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: AGENCY_AGREEMENT_QUERY_KEY,
    queryFn: () => companyService.getAgencyAgreement(),
    enabled: isAuthenticated,
    staleTime: 60_000,
  });
}
